import { render, staticRenderFns } from "./contract_list.vue?vue&type=template&id=fdd6592a&scoped=true&"
import script from "./contract_list.vue?vue&type=script&lang=js&"
export * from "./contract_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd6592a",
  null
  
)

export default component.exports